/*
 * @Author: ylq
 * @Date: 2022-09-20 16:24:20
 * @Desc: user Store
 * @Last Modified by: ylq
 * @Last Modified time: 2023-04-07 14:49:33
 */
import { defineStore } from 'pinia';

const useChatStore = defineStore('chatGpt', {
  state: () => ({
    list: []
  }),
  actions: {
    updateSettings(partial) {
      this.$patch(partial);
    }
  }
});

export default useChatStore;
